import { inject, toRef, computed, watch, openBlock, createElementBlock, unref, createVNode, mergeProps, withCtx, createElementVNode, Fragment, renderList, normalizeClass, toDisplayString } from "vue";
import { useField } from "vee-validate";
import UikitInputWrapper from "./InputWrapper.vue.es.js";
/* empty css                    */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "uikit-input-container" };
const _hoisted_3 = ["onClick"];
const _sfc_main = {
  __name: "InputFluids",
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      type: [String, Number, Array, Boolean],
      // Keep boolean in last to avoid auto casting
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: [String, Function],
      required: false,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    unselectable: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const isFormDisabled = inject("isFormDisabled", false);
    const isFormSkeleton = inject("isFormSkeleton", false);
    const name = toRef(props, "name");
    const { value, errorMessage, handleChange, handleBlur } = useField(name, props.rules, {
      initialValue: props.modelValue
    });
    const isDisabled = computed(() => isFormDisabled.value || props.disabled);
    const wrapperProps = computed(() => {
      return {
        errorMessage: errorMessage.value,
        skeleton: isFormSkeleton.value,
        disabled: isDisabled.value,
        loading: false
      };
    });
    const emit = __emit;
    const handleInputChange = (option) => {
      let newValue;
      if (isDisabled.value) {
        return;
      }
      if (props.multiSelect) {
        let currentValue = value.value ?? [];
        if (typeof currentValue === "string") {
          currentValue = [currentValue];
        }
        if (currentValue.includes(option.value)) {
          newValue = currentValue.filter((v) => v !== option.value);
        } else {
          newValue = [...currentValue, option.value];
        }
        if (props.unselectable && newValue.length === 0) {
          return;
        }
      } else {
        newValue = value.value === option.value ? null : option.value;
        if (props.unselectable && newValue === null) {
          return;
        }
      }
      handleChange(newValue);
      emit("update:modelValue", newValue);
    };
    watch(
      () => props.modelValue,
      (newValue) => {
        if (value.value !== newValue) {
          handleChange(newValue);
        }
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: __props.id,
        class: "uikit-input-fluids",
        onBlur: _cache[0] || (_cache[0] = (...args) => unref(handleBlur) && unref(handleBlur)(...args))
      }, [
        createVNode(UikitInputWrapper, mergeProps({ class: "input-fluids-input" }, wrapperProps.value), {
          input: withCtx(() => [
            createElementVNode("div", _hoisted_2, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option, index) => {
                var _a;
                return openBlock(), createElementBlock("div", {
                  key: index,
                  class: normalizeClass(["container", {
                    active: __props.multiSelect ? (_a = unref(value)) == null ? void 0 : _a.includes(option.value) : unref(value) === option.value
                  }]),
                  onClick: ($event) => handleInputChange(option)
                }, toDisplayString(option.label), 11, _hoisted_3);
              }), 128))
            ])
          ]),
          _: 1
        }, 16)
      ], 40, _hoisted_1);
    };
  }
};
const InputFluids = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-be93d0f5"]]);
export {
  InputFluids as default
};
//# sourceMappingURL=InputFluids.vue.es.js.map
